module.exports = __webpack_public_path__ + "img/アンロスト・ワールド.bdf0ef9f.png";